import React, { useMemo } from 'react';
import './MarioSenderFile.less';
import { IFile, UploadStatusEnum } from '@src/utils/local-files-helper';
import { CircleProgress } from '../CircleProgress';
import { Icon } from '@docs/kd-d2c-components';
import {
  eed_mario_icon_folder_code_area,
  eed_web_icon_global_06_state_cuowu_area,
} from '@src/assets/icons';
import { FileHelper } from '@src/utils/file';

const MarioSenderFile = ({
  file,
  progress,
  uploading,
  status,
  errorMessage,
  onHandleDeleteFile,
  onHandleRetryUpload,
}: {
  file: IFile;
  progress: number;
  uploading: boolean;
  status?: UploadStatusEnum;
  errorMessage?: string;
  onHandleDeleteFile?: () => void;
  onHandleRetryUpload?: () => void;
}) => {
  const type = useMemo(() => {
    return file?.fileType || FileHelper.getExtension(file.name);
  }, [file]);
  const icon = useMemo(() => {
    return FileHelper.getIcon(type);
  }, [file]);
  // 检查是否为图片格式
  const isImageFile = FileHelper.isImage(type);

  const _onClickToHandleFile = () => {
    if (status === UploadStatusEnum.FAILED && onHandleRetryUpload) {
      onHandleRetryUpload();
    } else if (onHandleDeleteFile) {
      onHandleDeleteFile();
    }
  };

  const getDisplaySize = (sizeInBytes: number) => {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    if (sizeInMB >= 1) {
      return `${sizeInMB.toFixed(2)} MB`;
    } else {
      const sizeInKB = sizeInBytes / 1024;
      return `${sizeInKB.toFixed(2)} KB`;
    }
  };

  return file ? (
    <div className="mario-sender-file-box">
      <div className="mario-sender-file-warp">
        {isImageFile ? (
          <div className="mario-sender-file-image">
            <img
              src={file.fileUrl || FileHelper.getDownloadUrl(file.objectKey || '')}
              alt=""
            />
          </div>
        ) : (
          <div className="mario-sender-file">
            <div className="mario-sender-file-icon">
              <Icon icon={icon || eed_mario_icon_folder_code_area} size={48} />
            </div>
            <div className="mario-sender-file-text">
              <div className="mario-sender-file-text-name">{file.name}</div>
              <div className="mario-sender-file-text-size">
                {getDisplaySize(file.size)}
              </div>
            </div>
          </div>
        )}
        <div
          className={`mario-sender-file-process ${
            isImageFile ? 'mario-sender-file-process-image' : ''
          }`}
        >
          {uploading ? (
            <CircleProgress
              width={22}
              iconWidth={16}
              percent={progress}
              strokeColor={'var(--color-tag-font-green)'}
              onClickIcon={_onClickToHandleFile}
              strokeColorBg={'var(--color-line-3)'}
            />
          ) : (
            <Icon
              icon={eed_web_icon_global_06_state_cuowu_area}
              size={16}
              onClick={_onClickToHandleFile}
              className="mario-sender-file-close-icon"
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default MarioSenderFile;
